<template>
  <div class="card">
    <v-container>
      <v-layout>
        <v-layout align-center>
          <div>
            <div class="icon-bg" @click="toggleExpend">
              <v-img :src="icon" max-width="35px" max-height="35px" />
            </div>
          </div>
          <div @click="toggleExpend">
            <h3 class="headline font-weight-bold">{{ title }}</h3>
          </div>
        </v-layout>

        <v-layout align-center justify-end>
          <v-btn
            v-if="btnLabel && btnCondition"
            @click.stop="toggleDrawer"
            color="primary"
          >
            {{ btnLabel }}
          </v-btn>
          <div>
            <v-switch
              v-show="editBtn && isExpanded"
              class="ml-4"
              label="Edit mode"
              v-model="editModeValue"
            />
          </div>
          <div @click="toggleExpend" class="arrow">
            <div v-if="expandable && isExpanded">
              <v-icon>keyboard_arrow_up</v-icon>
            </div>
            <div v-else-if="expandable">
              <v-icon>keyboard_arrow_down</v-icon>
            </div>
          </div>
        </v-layout>
      </v-layout>

      <div class="card-content">
        <div v-if="isExpanded">
          <slot />
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    editBtn: {
      type: Boolean,
      default: false,
      required: false,
    },
    expandable: {
      type: Boolean,
      default: false,
      required: false,
    },
    expanded: {
      type: Boolean,
      default: true,
      required: false,
    },
    drawer: {
      type: Boolean,
      required: false,
    },
    btnLabel: {
      type: String,
      required: false,
    },
    btnCondition: {
      type: Boolean,
      default: true,
      required: false,
    },
    icon: {
      type: String,
      default: "$vuetify.icons.cancel",
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  methods: {
    toggleDrawer() {
      return this.$emit("update:drawer", !this.drawer);
    },
    toggleExpend() {
      if (this.expandable) this.isExpanded = !this.isExpanded;
    },
  },
  computed: {
    editModeValue: {
      get() {
        return this.editMode;
      },
      set(value) {
        this.$emit("update:editMode", value);
      },
    },
  },
  mounted() {
    this.isExpanded = this.expanded;
  },
};
</script>

<style lang="stylus" scoped>
.icon-bg {
  background-color: #232753;
  height: 60px;
  width: 60px;
  border-radius: 30px;
  margin-right: 18px;
  color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;

  img {
    height: 18px;
    width: auto;
    fill: white;
  }
}

.arrow {
  width: 24px;
}

.card {
  width: 100%;
}

.card-content {
  padding-left: 30px;
  margin-top: 15px;
  margin-bottom: 40px;
}
</style>
